'use client';

import { Anchor } from '@components/common';
import { cn } from '@utils/cn';

interface TagProps {
  label: string;
  href?: string;
  className?: string;
  count?: number;
  /** When provided, prevents the default anchor navigation and calls this handler instead. */
  onClick?: () => void;
}

export const Tag = (props: TagProps) => {
  // Destructure props
  const {
    label, href, className, count, onClick,
  } = props;

  const isDisabled = typeof count === 'number' ? count === 0 : false;

  return (
    <Anchor
      aria-disabled={isDisabled}
      href={href}
      styling="none"
      className={cn(
        'border border-current flex gap-1 rounded-full bg-surface text-sm font-semibold px-4 py-1.5 hover:shadow-none',
        className,
        isDisabled && 'pointer-events-none opacity-50',
      )}
      onClick={onClick ? (e) => { e.preventDefault(); e.stopPropagation(); onClick(); } : undefined}
    >
      <span>{label}</span>
      {typeof count === 'number' ? <span>{`(${count})`}</span> : null}
    </Anchor>
  );
};
